import React from "react"
import LaundryTimerPicker from "../../../components/newComps/LaundryTimerPicker";
import {LazyLoadImage} from "react-lazy-load-image-component";

const Step3 = (props) => {
    let {boxIndex, _placeOrderCallback} = props;

    return (
        boxIndex == 2 ?
            <div className={'row'}>
                <div className={'col-md-12'}>
                    <div className={'locationPicker'}>
                        <div className="laundryPlaceOrder intro-info">
                            <div className={'logoBox'}>
                                <LazyLoadImage src="/assets/img/1StopWash-logo.svg"
                                               className="img-fluid"/>
                            </div>
                            <div id="custom-search-input">
                                <LaundryTimerPicker _placeOrderCallback={_placeOrderCallback} {...props}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            : null
    )
}
export default Step3
